<template lang="pug">
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/basic
ib-col(:class="{'insetx-16': $media.l, 'insetx-4': $media.s}", id="search-res")
    div(v-if="total > 0", class="flex-flex", :class="{'after-16': ids.length === 0}")
        ib-row
            ib-col
                div(class="before-16",
                    :class="{'outsetx-4': $media.xl, 'float-left': $media.xl, 'text-center': !$media.xl, 'after-8': !$media.xl}")
                    p(v-if="total > 0") {{ $t('showing') }}
                        span(v-if="curResults.length <= $num.int(total)", class="outsetx-4") {{ curResults.length }} {{ $t('of') }} {{ $num.int(total) }}
                        span(v-else, class="outsetx-4") {{ curResults.length }} {{ $t('of') }} {{ $num.int(total) }}
                        span(v-if="status === 'loading'")
                            ib-progress-circular(class="_ga_total_spinner", width="20px", height="20px")
    ib-row
        ib-col(id = "scroll", class="flex", style="max-height:65vh;")
            SearchTerm()
            ib-table-basic(
                :data="curResults",
                row,
                colborder
                rowstripe,
                class="fs7 fg70 shrink fin-table",
                spacing="huge",
                style="border: 1px solid rgba(0,0,0,0.15); overscroll-behavior:contain;",
                id="_ga-scroll-table"
            )
                ib-table-col(v-if="!$media.xl", width="3ch", sticky)
                    div(:class="{'border-bottom': ids.length === 0}")
                    div
                        span(class="weighted text-right")
                ib-table-col(width="14ch", sticky)
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('company')")
                        span(:title="$t('company_name')") {{ $t('company_name') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'company' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('company', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'company' && sort.dir === 'desc' }",
                                @click.stop="sortResults('company', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(:title="$t('weighted_average')") {{ $t('weighted_average') }}
                ib-table-col(width="8ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('ticker')")
                        span(:title="$t('ticker')") {{ $t('ticker') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'ticker' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('ticker', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'ticker' && sort.dir === 'desc' }",
                                @click.stop="sortResults('ticker', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="weighted text-right") -
                ib-table-col(width="10ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('country')")
                        span(:title="$t('country')") {{ $t('country') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'country' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('country', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'country' && sort.dir === 'desc' }",
                                @click.stop="sortResults('country', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="weighted text-right") -
                ib-table-col(width="9ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('sector')")
                        span(:title="$t('sector')") {{ $t('sector') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'sector' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('sector', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'sector' && sort.dir === 'desc' }",
                                @click.stop="sortResults('sector', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="weighted text-right") -
                ib-table-col(width="8ch") 
                    div(:class="{'border-bottom': ids.length === 0}")
                        span(:title="$t('price')") {{ $t('price') }}*
                    div(v-show="ids.length === 0")
                        span(class="weighted text-right") -
                ib-table-col(width="10ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('mkt_cap')")
                        span(:title="$t('mkt_cap')") {{ $t('mkt_cap') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'mkt_cap' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('mkt_cap', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'mkt_cap' && sort.dir === 'desc' }",
                                @click.stop="sortResults('mkt_cap', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="fg-70 fg-primary text-right weighted") {{ wCaps }}
                ib-table-col(width="8ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('ev')")
                        span(:title="$t('ev')") {{ $t('ev') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'ev' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('ev', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'ev' && sort.dir === 'desc' }",
                                @click.stop="sortResults('ev', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="fg-70 fg-primary text-right weighted") {{ wEnterprise }}
                ib-table-col(width="7ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('rev')")
                        span(:title="$t('rev')") {{ $t('rev') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'rev' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('rev', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down",
                                :class="{'active-sort': sort.type === 'rev' && sort.dir === 'desc' }",
                                @click.stop="sortResults('rev', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="fg-70 fg-primary text-right weighted") {{ wRevenue }}
                ib-table-col(width="10ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('earnings')")
                        span(:title="$t('earnings')") {{ $t('earnings') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'earnings' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('earnings', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down", 
                                :class="{'active-sort': sort.type === 'earnings' && sort.dir === 'desc' }", 
                                @click.stop="sortResults('earnings', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(v-if="parseFloat(wEarnings) > 0", class="fg-70 fg-primary text-right weighted") {{ wEarnings }}
                        span(v-else, class="weighted text-right") -
                ib-table-col(width="12ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('eps')")
                        span(:title="$t('eps')") {{ $t('eps') }} %
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'eps' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('eps', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down", 
                                :class="{'active-sort': sort.type === 'eps' && sort.dir === 'desc' }", 
                                @click.stop="sortResults('eps', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(class="fg-70 fg-primary text-right weighted") {{ wEPS }}%
                ib-table-col(width="10ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('div')")
                        span(:title="$t('div')") {{ $t('div') }} %
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'div' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('div', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down", 
                                :class="{'active-sort': sort.type === 'div' && sort.dir === 'desc' }", 
                                @click.stop="sortResults('div', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(v-if="parseFloat(wDY) > 0", class="fg-70 fg-primary text-right weighted") {{ wDY }}%
                        span(v-else, class="weighted text-right") -
                ib-table-col(width="7ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('pe')")
                        span(:title="$t('pe')") {{ $t('pe') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'pe' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('pe', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down", 
                                :class="{'active-sort': sort.type === 'pe' && sort.dir === 'desc' }", 
                                @click.stop="sortResults('pe', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(v-if="parseFloat(wPES) > 0", class="fg-70 fg-primary text-right weighted") {{ wPES }}
                        span(v-else, class="weighted text-right") -
                ib-table-col(width="7ch")
                    div(:class="{'border-bottom': ids.length === 0}", @click.stop="sortResults('peg')")
                        span(:title="$t('peg')") {{ $t('peg') }}
                        span(v-show="ids.length === 0")
                            span(
                                class="up", 
                                :class="{'active-sort': sort.type === 'peg' && sort.dir === 'asc' }", 
                                @click.stop="sortResults('peg', 'asc')"
                            )
                                +icon-arrow-sort_up_filled
                            span(
                                class="down", 
                                :class="{'active-sort': sort.type === 'peg' && sort.dir === 'desc' }", 
                                @click.stop="sortResults('peg', 'desc')"
                            )
                                +icon-arrow-sort_down_filled
                    div(v-show="ids.length === 0")
                        span(v-if="parseFloat(wPEGS) > 0", class="fg-70 fg-primary text-right weighted") {{ wPEGS }}
                        span(v-else, class="weighted text-right") -
                template(id="table_basic", slot="body", slot-scope="res")
                    td(class="padding-zero", v-if="!$media.xl")
                        span(class="info results", @click="showResultModal(res)")
                            +icon-basic-info_filled
                    td(class="row_tracker", :data-conid="res['conid']", @click="getMoreInfo", :title="formatComp(res['company'])") {{ formatComp(res['company']) }}
                    td(@click="getMoreDetails(res['company'], res['conid'])", :title="res['ticker']")
                        span(class="fg-accent") {{ res['ticker'] }}
                    td(@click="getMoreInfo", :title="res['company_cntry']", v-text="res['company_cntry']")
                    td(@click="getMoreInfo", :title="res['industry']", v-text="res['industry']")
                    td(@click="getMoreInfo", :title="res['conv_price']")
                        div(v-if="!res['conv_price']" class="spin")
                        span(v-else, class="text-right weighted") {{ res['conv_price'] }}
                    td(@click="getMoreInfo", :title="getFormat(res['conv_mkt_cap'])", class="text-right") {{ getFormat(res['conv_mkt_cap']) }}
                    td(@click="getMoreInfo", :title="getFormat(res['conv_ev_cur'])", class="text-right") {{ getFormat(res['conv_ev_cur']) }}
                    td(:title="setExchRev(res['ttmrev'])", class="text-right") {{ setExchRev(res['ttmrev']) }}
                    td(@click="getMoreInfo", :title="setExchNI(res['ttmebitd'])", class="text-right") {{ setExchNI(res['ttmebitd']) }}
                    td(:title="getGrowth(res['epsgrpct'])", class="text-right") {{ getGrowth(res['epsgrpct'])  }}
                    td(:title="getYield(res['divyield'])", class="text-right") {{ getYield(res['divyield']) }}
                    td(@click="getMoreInfo", :title="getFixed(res['peexclxor'])", class="text-right") {{ getFixed(res['peexclxor']) }}
                    td(@click="getMoreInfo", :title="getRatio(res['peg'])", class="text-right") {{ getRatio(res['peg']) }}
                template(slot="foot")
                    LoadMore(v-if="ids.length === 0 && this.total - this.curResults.length > 1", @intersecting="loadMore")
    InfoModal(v-if="picked !== null", :picked="picked", type="stock", ref="infoModal")
    DetailsModal(ref="detailInfoTwo")
    ib-dialog(
        :autoclose="true",
        ref="modal",
        v-model="showLoginScreen"
        class="login-dialog"
    )
        div(class="inner-modal")
            div(class="add-info flex-fixed top")
                h3 {{ $t('login') }}
                a(@click="closeModal")
                    span(class="fg")
                        +icon-basic-cancel
            div(class="modal-body")
                h5(class="text-center") {{ $t('login_to_portal') }}
                p(class="text-center")
                    ib-button(class="bg-accent _btn act", @click.prevent="addFilters")  {{ $t('have_existing_account') }}
                br
                h5(class="text-center") {{ $t('no_account') }} {{ $t('open_one') }}
                p(class="text-center after-16")
                    a(class="bg-accent _btn act" href="https://www.interactivebrokers.com/en/index.php?f=4695") {{ $t('open_ib_account') }}
    
</template>
<script>

import { mapState, mapActions } from 'vuex';

import ChangeCurrency from './ChangeCurrency.vue';
import InfoModal from './InfoModal.vue';
import SearchTerm from './SearchTerm.vue';
import LoadMore from './LoadMore.vue';
import FilterOptions from './FilterOptions.vue';
import DetailsModal from './DetailsModal.vue';
import api from '../api/';
import { formatMixin } from '../js/formatting.js';
import { priceMixin } from '../js/price';
import { searchMixin } from '../js/search';

const sso = 'https://www.interactivebrokers.com/sso/Login';
const MAX_ROWS = 50;
    export default {
        name: 'SearchResults',
        components: {
            ChangeCurrency,
            InfoModal,
            SearchTerm,
            LoadMore,
            FilterOptions,
            DetailsModal
        },

        // props: ['responses','currency','industries','countries','range','companies', 'filters', 'showType', 'wCaps', 'wEnterprise', 'wRevenue', 'wEarnings', 'wEPS', 'wPEGS', 'wDY', 'wPES', 'passComp', 'passInd', 'passAsset', 'currencyConversions'],
        // props: ['resultsResponse', 'averagesResponse'],
        mixins: [formatMixin, priceMixin, searchMixin],
        data() {
            return {
                amSession: window.AM_SESSION_ID,
                portalUrl: window.PORTAL_BASE_URL,
                originUrl: window.location.origin,
                curResults: [],
                searchResults: [],
                showLoginScreen: false,
                signedIn: false,
                total: 0,
                loadingMore: false,
                picked: null,
                wCaps: '',
                wEnterprise: '',
                wRevenue: '',
                wEarnings: '',
                wEPS: '',
                wDY: '',
                wPES: '',
                wPEGS: '',
            }
        },

        created() {
           this.checkSignedIn();
        },

        methods: {
            showResultModal(res) {
                this.picked = res;
                Vue.nextTick(()=> {
                    this.$refs.infoModal.show();
                }) 
            },
            loadMore(value) {
                if (this.loadingMore || !value) return;
                this.loadingMore = true;
                this.setCurrentPage(this.currentPage + 1);
                this.search({skipAvg: true});
                console.debug('Loading more...');
            },
            addFilters() {
                window.location.href = `${sso}`;
            },

            checkSignedIn() {
                if (typeof amSession !== 'undefined' || typeof portalUrl !== 'undefined') {
                    this.signedIn = true;
                } else {
                    api.checkCP()
                        .then(res => {
                            if (res && res["RESULT"] === true) {
                                this.signedIn = true;
                            }
                        })
                        .catch(error => {
                            //console.log(error);
                        })
                }
            },

            closeModal() {
                this.showLoginScreen = false;
            },

            getMoreDetails(name, conid) {
                this.$refs.detailInfoTwo.open(name, conid);
            },

            getMoreInfo() {
                if (this.signedIn || this.originUrl.includes("globaltrader")) {
                    this.showLoginScreen = false;
                } else {
                    this.showLoginScreen = true;
                }
            },
            /**
             * Handles populating results table & table interactions
             * 
             * @param {string} curr - an optional currency
             */
            getReuters(curr) {
                if (this.resultsResponse.res.length <= 50) {
                    console.debug(this.resultsResponse.total);
                    document.getElementById('_ga-scroll-table').parentNode.scrollTo(0,0);
                }
                this.curResults = this.resultsResponse.res;
                this.loadingMore = false;
                this.total = this.resultsResponse.total;
                Vue.nextTick(() => {
                    this.initialized('#search-res', '.row_tracker', false);
                });
            },

            sortResults(type, dir) {
                // Don't sort column again if already sorted.
                if (this.sort.type && (this.sort.type === type && this.sort.dir === dir)) {
                    return;
                }
                if (this.ids.length > 0) {
                    return;
                }
                if (!dir) {
                    this.direction = !this.direction;
                    if (this.direction) {
                        dir = 'desc';
                    } else {
                        dir = 'asc';
                    }
                }
                this.setSorting({type,dir})
                this.setCurrentPage(1);
                this.curResultsMapping.clear();
                this.search({skipAvg: true});
            },
            getTotals() {
                // caps array will hold weight
                const caps = [];

                // mkt_caps array will hold conv_mkt_cap
                const mkt_caps = [];
                const evs = [];
                const revs = [];
                const earn = [];
                const epsgrowth = [];
                const dyields = [];
                const pes = [];
                const pegs = [];
                const responses = this.averagesResponse.res;
                responses.map(r => caps.push(+r['conv_mkt_cap']))
                let sum = '';
                if (caps.length > 1) {
                    sum = caps.reduce((prev, next) => prev + next);
                } else {
                    sum = caps[0];
                }
                responses.map(r => {
                    let weight = (+r['conv_mkt_cap']/sum);

                    let wmktcap = weight * +r['conv_mkt_cap'];
                    //console.log( "weight", "conv_mkt_cap", `${ weight }`, `${ +r['conv_mkt_cap'] }` )

                    let wev = weight * +r['conv_ev_cur'];
                    //console.log( "weight", "conv_ev_cur", `${ weight }`, `${ +r['conv_ev_cur'] }` )

                    let wrev = weight * +r['ttmrev'];
                    //console.log( "weight", "ttmrev", `${ weight }`, `${ +r['ttmrev'] }` )

                    let wttmebitd = weight * +r['ttmebitd'];
                    //console.log( "weight", "ttmebitd", `${ weight }`, `${ +r['ttmebitd'] }` )

                    let wepsgrow = weight * +r['epsgrpct'];
                    //console.log( "weight", "epsgrpct", `${ weight }`, `${ +r['epsgrpct'] }` )

                    let wdiv = weight * +r['divyield'];
                    //console.log( "weight", "divyield", `${ weight }`, `${ +r['divyield'] }` )

                    let wpe = weight * +r['peexclxor'];
                    //console.log( "weight", "peexclxor", `${ weight }`, `${ +r['peexclxor'] }` )

                    let wpeg = weight * +r['peg'];
                    //console.log( "weight", "peg", `${ weight }`, `${ +r['peg'] }` )

                    mkt_caps.push(wmktcap);
                    evs.push(wev);
                    revs.push(wrev);
                    earn.push(wttmebitd);
                    epsgrowth.push(wepsgrow)
                    dyields.push(wdiv);
                    pes.push(wpe);
                    pegs.push(wpeg);
                });
                //  Set Weighted Mkt Caps

                let wCap = 0;
                if (mkt_caps.length > 1) {
                    wCap = mkt_caps.reduce((prev, next) => prev + next);
                } else {
                    wCap = mkt_caps[0];
                }
                //console.log("weightedCaps:", wCap);
                let conv_wCap = "";
                if (wCap >= 1000000000000) {
                    wCap = (wCap/1000000000000).toFixed(2);
                    conv_wCap = `${wCap}T`;
                    //console.log("conv_wCap:", conv_wCap);
                    this.wCaps = conv_wCap;
                } else if (wCap < 1000000000000 && wCap >= 1000000000) {
                    wCap = (wCap/1000000000).toFixed(2);
                    conv_wCap = `${wCap}B`;
                    //console.log("conv_wCap:", conv_wCap);
                    this.wCaps = conv_wCap;
                } else {
                    wCap = (wCap/1000000).toFixed(2);
                    conv_wCap = `${wCap}M`;
                    //console.log("conv_wCap:", conv_wCap);
                    this.wCaps = conv_wCap;
                }

                //  Set Weighted EVs

                let wEVS = 0;
                if (evs.length > 1) {
                    wEVS = evs.reduce((prev, next) => prev + next);
                } else {
                    wEVS = evs[0];
                }
                //console.log("weightedEVS:", wEVS);
                let conv_wEVS = "";
                if (wEVS >= 1000000000000) {
                    wEVS = (wEVS/1000000000000).toFixed(2);
                    conv_wEVS = `${wEVS}T`;
                    //console.log("conv_wEVS:", conv_wEVS);
                    this.wEnterprise = conv_wEVS;
                } else if (wEVS < 1000000000000 && wEVS >= 1000000000) {
                    wEVS = (wEVS/1000000000).toFixed(2);
                    conv_wEVS = `${wEVS}B`;
                    //console.log("conv_wEVS:", conv_wEVS);
                    this.wEnterprise = conv_wEVS;
                } else {
                    wEVS = (wEVS/1000000).toFixed(2);
                    conv_wEVS = `${wEVS}M`;
                    //console.log("conv_wEVS:", conv_wEVS);
                    this.wEnterprise = conv_wEVS;
                }

                //  Set Revenue

                let wRevs = 0;
                if (revs.length > 1) {
                    wRevs = revs.reduce((prev, next) => prev + next);
                } else {
                    wRevs = revs[0];
                }
                let conv_wRevs = "";
                if (wRevs >= 1000000) {
                    wRevs = (wRevs/1000000).toFixed(2);
                    conv_wRevs = `${wRevs}T`;
                    //console.log("conv_wRevs:", conv_wRevs);
                    this.wRevenue = conv_wRevs;
                } else if (wRevs < 1000000 && wRevs >= 1000) {
                    wRevs = (wRevs/1000).toFixed(2);
                    conv_wRevs = `${wRevs}B`;
                    //console.log("conv_wRevs:", conv_wRevs);
                    this.wRevenue = conv_wRevs;
                } else {
                    wRevs = wRevs.toFixed(2);
                    conv_wRevs = `${wRevs}M`;
                    //console.log("conv_wRevs:", conv_wRevs);
                    this.wRevenue = conv_wRevs;
                }

                //  Set Earnings

                let filteredEarn = earn.filter(ern => ern > 0);
                if (filteredEarn.length === 0) {
                    filteredEarn.push(...earn);
                }
                //console.log("filteredEarn:", filteredEarn);
                let wEarn = 0;
                if (filteredEarn.length > 1) {
                    wEarn = filteredEarn.reduce((prev, next) => prev + next);
                } else {
                    wEarn = filteredEarn[0];
                }
                //console.log("weightedEarn:", wEarn);
                let conv_wEarn = "";
                if (wEarn >= 1000000) {
                    wEarn = (wEarn/1000000).toFixed(2);
                    conv_wEarn = `${wEarn}T`;
                    //console.log("conv_wEarn:", conv_wEarn);
                    this.wEarnings = conv_wEarn;
                } else if (wEarn < 1000000 && wEarn >= 1000) {
                    wEarn = (wEarn/1000).toFixed(2);
                    conv_wEarn = `${wEarn}B`;
                    //console.log("conv_wEarn:", conv_wEarn);
                    this.wEarnings = conv_wEarn;
                } else {
                    wEarn = wEarn.toFixed(2);
                    conv_wEarn = `${wEarn}M`;
                    //console.log("conv_wEarn:", conv_wEarn);
                    this.wEarnings = conv_wEarn;
                }

                // Set EPS Growth

                let wEPS = 0;
                if (epsgrowth.length > 1) {
                    wEPS = epsgrowth.reduce((prev, next) => prev + next);
                } else {
                    wEPS = epsgrowth[0];
                }
                //console.log("weightedEPSGrowth:", wEPS);
                this.wEPS = wEPS.toFixed(2);

                // Set Dividend Yield

                let filterDY = dyields.filter(dy => dy > 0);
                if (filterDY.length === 0) {
                    filterDY.push(...dyields);
                }
                //console.log("filterDY:", filterDY);
                let wDY = 0;
                if (filterDY.length > 1) {
                    wDY = filterDY.reduce((prev, next) => prev + next);
                } else {
                    wDY = filterDY[0];
                }
                //console.log("weightedDivYield:", wDY);
                this.wDY = wDY.toFixed(2);

                //Set PE

                let filteredPE = pes.filter(pe => pe > 0);
                if (filteredPE.length === 0 ) {
                    filteredPE.push(...pes)
                }
                //console.log("filteredPE:", filteredPE);
                let wPE = 0;
                if (filteredPE.length > 1) {
                    wPE = filteredPE.reduce((prev, next) => prev + next);
                } else {
                    wPE = filteredPE[0];
                }
                //console.log("weightedPE:", wPE);
                this.wPES = wPE.toFixed(2);

                //Set PEG

                let filteredPEG = pegs.filter(peg => peg > 0);
                if (filteredPEG.length === 0 ) {
                    filteredPEG.push(...pegs)
                }
                //console.log("filteredPEG:", filteredPEG);
                let wPEG = 0;
                if (filteredPEG.length > 1) {
                    wPEG = filteredPEG.reduce((prev, next) => prev + next);
                } else {
                    wPEG = filteredPEG[0];
                }
                //console.log("weightedPEG:", wPEG);
                this.wPEGS = wPEG.toFixed(2); 
            },
            ...mapActions(['setCurrentPage','setSorting', 'search'])
        },

        mounted() {
            this.getReuters();
            this.getTotals();
        },
        computed : {
            /* Added the below 2 computed properties to avoid entire variable refactor. */
            resultsResponse: function() {
                return this.listedResults;
            },
            averagesResponse: function() {
                console.log('this.averages value is', this.averages);
                return this.averages;
            },
            ...mapState(['currentPage','currencyConversions', 'sort', 'marketDataPrices', 'ids', 'averages', 'listedResults', 'status']),
            
        },

        watch: {
            resultsResponse: {
                handler: function(newVal, oldVal) {
                    this.getReuters();
                },
            },
            averagesResponse: {
                handler: function(newVal, oldVal) {
                    this.getTotals();
                },
            },
        }
    }
</script>
<style lang="less" scoped>
    span {
        .up {
            position: relative;
            right: -6px;
            top: -6px;
            &.active-sort {
                color: #000;
            }
        }
        .down {
            position: relative;
            left: -5px;
            top: 4px;
            &.active-sort {
                color: #000;
            }
        }
    }
    ._con {
        svg {
            width: 1em;
            height: 1em;
        }
    }
    .disclosures {
        max-width: 1140px;
        margin: 0 auto 40px;
    }
    .notes {
        max-width: 1140px;
        margin: 40px auto;
        padding: 10px 30px;
        background-color: #EDF0F5;
        p {
            font-size: 0.6875rem;
            line-height: 0.9375rem;
            color: #666;
        }
    }
    @media (min-width: 576px) {
        .notes { max-width: 540px; }
    }
    @media (min-width: 768px) {
        .notes { max-width: 720px; }
    }
    @media (min-width: 992px) {
        .notes { max-width: 960px; }
    }
    @media (min-width: 1200px) {
        .notes { max-width: 1140px; }
    }

    p {
        &.sm-print {
            text-transform: capitalize;
            font-size: 9px;
        }
    }

    #page {
        width: 3em;
        vertical-align: top;
    }

    .page-box {
        padding: 3px;
        svg {
            width: 1.125em !important;
            height: 1.125em !important;
        }
    }

    .rowbox {
        width: 100%;
    }

    .hover {
        &:hover {
            border-color: #000;
            color: #000;
        }
    }
    .hover-black {
        &:hover {
            background: #000;
            border-color: #000;
        }
    }

    .weighted {
        display: block;
    }
</style>
